import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/billing/pages/settings/RootPage'))

const UpgradeSubscriptionModalPage = React.lazy(
  () => import('modules/billing/pages/settings/UpgradeSubscriptionModalPage')
)

const ExpensesPlanPage = React.lazy(
  () => import('modules/expenses/pages/subscription/ExpensesPlanPage')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.plans.path,
      element: <RootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('company_settings.general.subscription.title'),
          description: i18n.t('company_settings.general.subscription.description'),
          illustration: 'boxes',
        }),
      },
      children: [
        {
          path: navigation.settings.plans.expenses.path,

          handle: {
            meta: () => ({
              title: i18n.t('billing.subscription.plans.expenses.title'),
              description: i18n.t('billing.subscription.plans.expenses.description'),
              illustration: 'user-male-female',
            }),
          },
          element: <ExpensesPlanPage />,
        },
        {
          path: navigation.settings.plans.upgrade.path,
          element: <UpgradeSubscriptionModalPage />,
        },
      ],
    },
  ]
}

export default settingsRoutes
